<template>
<div class="chapter">
<div class="inner_page">
<p class="C274"><em><a id="page_xi">Translator’s Note</a></em></p><a id="page_xi">
<p class="P22">First and foremost, my deepest thanks to Rémi Brague for his invaluable assistance. He has corrected many errors in my translation and given me unfailing encouragement. If infelicities remain, they are mine, but there would have been many more of them without his help.</p>
<p class="P23">Quotations that are not credited in the notes as taken from an English-language publication are my translations from the French edition.</p>
<p class="P23">Any reader with a command of Arabic or Hebrew will smile at the Gallic lilt of the transliterations presented in the text, as they have been lifted shamelessly from the French edition.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Translator_s_Note.vue?11765fc1